import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FieldRuleValidationType } from '@sb-tools/typescript/enums/field-rule-validation-type.enum';

@Pipe({
    name: 'fieldRuleValidationTypeName',
})
export class FieldRuleValidationTypeNamePipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform(type: FieldRuleValidationType): string {
        switch (type) {
            case FieldRuleValidationType.equalTo:
                return this.translateService.instant('equal to');
            case FieldRuleValidationType.notEqualTo:
                return this.translateService.instant('not equal to');
            case FieldRuleValidationType.isOneOf:
                return this.translateService.instant('is one of');
            case FieldRuleValidationType.isNotOneOf:
                return this.translateService.instant('is not one of');
            case FieldRuleValidationType.containsAnyOf:
                return this.translateService.instant('contains any of');
            case FieldRuleValidationType.containsAllOf:
                return this.translateService.instant('contains all of');
            case FieldRuleValidationType.containsNoneOf:
                return this.translateService.instant('contains none of');
            case FieldRuleValidationType.equalsInAnyOrder:
                return this.translateService.instant('equals (in any order)');
            case FieldRuleValidationType.isNotEmpty:
                return this.translateService.instant('not empty');
            case FieldRuleValidationType.startsWith:
                return this.translateService.instant('starts with');
            case FieldRuleValidationType.contains:
                return this.translateService.instant('contains');
            case FieldRuleValidationType.notContains:
                return this.translateService.instant('not contains');
            case FieldRuleValidationType.isChecked:
                return this.translateService.instant('is checked');
        }
    }
}
